// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "body {\n  background-color: #181824;\n  font-family: \"segoe ui light\";\n}", "",{"version":3,"sources":["/opt/build/repo/src/styles.scss","styles.scss"],"names":[],"mappings":"AAGA;EACI,yBAHK;EAIL,6BAHQ;ACCZ","file":"styles.scss","sourcesContent":["\n$bodyBg: #181824;\n$fontFamily:'segoe ui light';\nbody{\n    background-color : $bodyBg;\n    font-family: $fontFamily;\n}","body {\n  background-color: #181824;\n  font-family: \"segoe ui light\";\n}"]}]);
// Exports
module.exports = exports;
